import { Button, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { makeRequest } from "../makeRequest";
import Title from "../components/Title";

function CancelRegistration() {
  const { id } = useParams();
  const [isStartingSoon, setIsStartingSoon] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    getRegistration();
  }, [id]);

  const getRegistration = async () => {
    try {
      await makeRequest.get("/registrations/" + id).then((res) => {
        if (res.data) {
          coursStartSoon(res.data.coursId);
        } else {
          setError(true);
        }
      });
    } catch (error) {
      console.error("Erreur lors de la récupération de l'inscription :", error);
      setError(true);
    }
  };

  const coursStartSoon = async (coursId) => {
    try {
      await makeRequest
        .get("/cours/" + coursId + "/isStartingSoon")
        .then((res) => {
          setIsStartingSoon(res.data.isStartingSoon);
        });
    } catch (error) {
      console.error("Erreur lors de la vérification du cours :", error);
    }
  };

  const deleteRegistration = async () => {
    setLoading(true);
    setError(false);
    try {
      await makeRequest.get("/registrations/delete-registration/" + id);
      setTimeout(() => {
        setLoading(false);
        setSuccess(true);
      }, 2000);
    } catch (error) {
      setLoading(false);
      setError(true);
    }
  };

  const quitterPage = () => {
    window.close();
  };

  return (
    <div className="w-screen h-screen poppins flex sm:flex-col gap-8 justify-center items-center">
      {!success && !error && (
        <Button
          onClick={deleteRegistration}
          variant="contained"
          disabled={isStartingSoon || loading}
          color="error"
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            "Annuler mon inscription"
          )}
        </Button>
      )}
      {success && (
        <div className="flex flex-col items-center gap-4">
          <div className="text-green-600  text-center font-bold text-lg">
            Annulation réussie ! Un courriel de confirmation vous sera envoyé.
          </div>
          <Button variant="contained" color="primary" onClick={quitterPage}>
            Quitter cette page
          </Button>
        </div>
      )}
      {error && (
        <div className="flex flex-col items-center gap-4">
          <div className="text-red-600 font-bold text-center text-lg">
            Une erreur est survenue. Veuillez nous contacter pour annuler votre
            inscription.
          </div>
          <Button variant="contained" color="error">
            Erreur
          </Button>
        </div>
      )}
    </div>
  );
}

export default CancelRegistration;
